import PropTypes from 'prop-types';
import React from 'react';

const FormRadio = (props) => {
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) { 
      props.onChange(e);
    }
  };
  return (
    <div className={`form-check ${props.containerClassName}`}>
    <input
      className="form-check-input"
      type="radio"
      name={props.name}
      checked={props.checked}
      id={props.id}
      onChange={props.onChange}
      onKeyDown={handleKeyDown}
    />
    <label name={props.name} className={`form-check-label ${props.labelClassName}`}  htmlFor={props.labelFor}>{props.label}</label>
  </div>
  );
};
FormRadio.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  labelFor: PropTypes.string,
};
export default React.memo(FormRadio);


